module.exports = __webpack_public_path__ + "static/img/img4.c21d56c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img4.jpg
// module id = q7tv
// module chunks = 0